export default __webpack_public_path__ + "static/media/ambient-bright-blue-pink.3a37382b.jpg";